import { type FormEvent, type FunctionComponent } from "react";
import { NumberPlateInput } from "@App/Components/NumberPlateInput";
import { useTranslation } from "react-i18next";
import { Button } from "@App/Components/Funnel/Button";

export type AgentNumberPlateInputFormProps = {
  numberPlate: string | null;
  error?: string;
  setNumberPlate: (numberPlate: string) => void;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
};

export const AgentNumberPlateInputForm: FunctionComponent<AgentNumberPlateInputFormProps> = ({
  numberPlate,
  error,
  setNumberPlate,
  onSubmit,
}: AgentNumberPlateInputFormProps) => {
  const { t } = useTranslation();

  return (
    <form onSubmit={onSubmit} noValidate>
      {" "}
      {/* Added noValidate to prevent browser default validation popups */}
      <label htmlFor="numberPlate" className="block text-sm/6 font-medium text-gray-900">
        {t("vehicleSelector.numberPlate")}
      </label>
      <div>
        <NumberPlateInput value={numberPlate} onChange={setNumberPlate} />
      </div>
      {error && (
        <p id="number-plate-error" className="mt-2 text-sm text-error-600" role="alert">
          {error}
        </p>
      )}
      <Button title={t("vehicleSelector.searchNumberPlate")} width={"md:w-full"} type={"submit"} />
    </form>
  );
};
